var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /Volumes/Data/projecten/uw-schilderwerk-website/node_modules/core-js/modules/_html.js
// module id = 31
// module chunks = 11